import React from 'react'
import PropTypes from 'prop-types'
import { TagBox } from '../../molecules/TagBox'
import { getStateByCode } from '../../../configs/answerConfig'

const AnswerTagBox = ({ answer }) => {
  const tagLabel = answer.status.label
  const tagType = getStateByCode(tagLabel).tagType

  return <TagBox label={tagLabel} tagType={tagType} />
}

export default AnswerTagBox

AnswerTagBox.propTypes = {
  answer: PropTypes.object
}
